import t from './skins/LW/text';
export * from './skins/LW/text';
export default t;
